__turbopack_context__.v({
  "noPadding": "RichText-module__W-yNhG__noPadding",
  "overflownText": "RichText-module__W-yNhG__overflownText",
  "richText": "RichText-module__W-yNhG__richText",
  "richTextCtaContainer": "RichText-module__W-yNhG__richTextCtaContainer",
  "viewMore": "RichText-module__W-yNhG__viewMore",
});
